import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const BusRoute = () => {
  const homeMenu = [
    { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Bus Route"
                breadEnd="Bus Route"
                breadMid="Bus Route"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-box">
              <p>
                The distinct feature of our bus route system is that each bus is
                boarded and deboarded from within the school campus under strict
                supervision. We have unique concept of boundary wall having bus
                gates. Our Air-conditioned Buses are supported with a Guard, a
                Helper and a Teacher and Nanny. For security and safety each bus
                is equipped with a First Aid box and a mobile phone. Attendance
                of children boarding the buses is taken both; in the morning and
                afternoon. We cater to the areas in and around Gurgaon and
                Delhi.
              </p>
              <p>
                For any transport related query contact the Transport Incharge.
              </p>
              <div class="download-btn mb-4">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/schooltransportregulations.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="bi bi-book-half"></i> School Transport Regulations
                </Link>
              </div>
              <div class="time-table table table-bus-routes">
                <table className="" width="100%" border="1">
                  <thead>
                    <tr>
                      <th width="7%" scope="col">
                        SNO
                      </th>
                      <th width="20%" scope="col">
                        ROUTE NO.
                      </th>
                      <th width="55%" scope="col">
                        AREAS COVERED BY THE BUS
                      </th>
                      <th width="18%" scope="col">
                        GUARD MOBILE NO.
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1 </td>
                      <td>ROUTE NO. 1</td>
                      <td>
                        Surya vihar kapashera border Palam Vihar, 21,22,23,
                      </td>
                      <td>9289268501 </td>
                    </tr>
                    <tr>
                      <td>2 </td>
                      <td>ROUTE NO. 2</td>
                      <td>
                        Vipul World Sec 48, Ildeco mansionz, Central Park 48,
                        Uniword Garden 1,
                      </td>
                      <td>9289268502 </td>
                    </tr>
                    <tr>
                      <td>3 </td>
                      <td>ROUTE NO. 3</td>
                      <td>Uppal Southend, The Nile , Sector- 49</td>
                      <td>9289268503 </td>
                    </tr>
                    <tr>
                      <td>4 </td>
                      <td>ROUTE NO. 4</td>
                      <td>Tulip Violet Society sector- 69,</td>
                      <td>9289268504 </td>
                    </tr>
                    <tr>
                      <td>5 </td>
                      <td>ROUTE NO. 5</td>
                      <td>
                        Park View Sector- 67, Ireo Victory Valley, M3M Merlin
                        Sector- 67,
                      </td>
                      <td>9289268505 </td>
                    </tr>
                    <tr>
                      <td>6 </td>
                      <td>ROUTE NO. 6</td>
                      <td>
                        Emaar palm Garden,lifestyle ,Vatika next ,City home,
                        Primous
                      </td>
                      <td>9289268506 </td>
                    </tr>
                    <tr>
                      <td>7 </td>
                      <td>ROUTE NO. 7</td>
                      <td>
                        Kendriya Vihar, Devender Vihar, Alakhnanda Apart, Ganesh
                        Apart,
                        <br />
                        Sushant Lok 2, Jalyauv Tower, Sector- 56
                      </td>
                      <td>9289268507 </td>
                    </tr>
                    <tr>
                      <td>8 </td>
                      <td>ROUTE NO. 8</td>
                      <td>Oakwood Estate Dlf Phase II, Essal Tower</td>
                      <td>9289268508 </td>
                    </tr>
                    <tr>
                      <td>9 </td>
                      <td>ROUTE NO. 9</td>
                      <td>Malibu Town, OD, White wood Street, Sector-47</td>
                      <td>9289268509 </td>
                    </tr>
                    <tr>
                      <td>10 </td>
                      <td>ROUTE NO. 10</td>
                      <td>
                        Bestech Park View, Today blossom, Urja Tower, Uniword
                        Garden II Sector 47, Sector 38
                      </td>
                      <td>9289268510 </td>
                    </tr>
                    <tr>
                      <td>11 </td>
                      <td>ROUTE NO. 11</td>
                      <td>Spaze Privy Sec-72, CHD Avenue Sec- 71</td>
                      <td>9289268511 </td>
                    </tr>
                    <tr>
                      <td>12 </td>
                      <td>ROUTE NO. 12</td>
                      <td>M3M Golf Estate Sec- 65, , Emaar Emerald Hills</td>
                      <td>9289268512 </td>
                    </tr>
                    <tr>
                      <td>13 </td>
                      <td>ROUTE NO. 13</td>
                      <td>Ireo Skyon Sec-60,Pioneer Park Sec-61,Sector 63</td>
                      <td>9289268513 </td>
                    </tr>
                    <tr>
                      <td>14 </td>
                      <td>ROUTE NO. 14</td>
                      <td>
                        Paras Irene Sec-70A ,AIPl Peacfull Home,M3M Escala
                        Sec-70A, Bptp
                        <br />
                        Astaire Garden,
                      </td>
                      <td>9289268514 </td>
                    </tr>
                    <tr>
                      <td>15 </td>
                      <td>ROUTE NO. 15</td>
                      <td>
                        Sushant Lok II,III Sector 57,The Legent ,Rail Vihar
                        Sec-57 .
                      </td>
                      <td>9289268515 </td>
                    </tr>
                    <tr>
                      <td>16 </td>
                      <td>ROUTE NO. 16</td>
                      <td>Ardee City</td>
                      <td>9289268516 </td>
                    </tr>
                    <tr>
                      <td>17 </td>
                      <td>ROUTE NO. 17</td>
                      <td>Valley View Estate Gwal Pahadi, Sector 55 Gurgaon</td>
                      <td>9289268517 </td>
                    </tr>
                    <tr>
                      <td>18 </td>
                      <td>ROUTE NO. 18</td>
                      <td>
                        Belvender park ,DLF Phase III, Plf Phase 1 Gurgaon
                      </td>
                      <td>9289268518 </td>
                    </tr>
                    <tr>
                      <td>19 </td>
                      <td>ROUTE NO. 19</td>
                      <td>
                        Sector 4, 7, New Colony , Shiv Puri ,Sector 51 Gurgaon
                      </td>
                      <td>9289268519 </td>
                    </tr>
                    <tr>
                      <td>20 </td>
                      <td>ROUTE NO. 20</td>
                      <td>Sector 30, South City I Gurgaon,Sector 31</td>
                      <td>9289268520 </td>
                    </tr>
                    <tr>
                      <td>21 </td>
                      <td>ROUTE NO. 21</td>
                      <td>
                        South City II, Nirvana Country, Sispal Vihar Gurgaon
                      </td>
                      <td>9289268521 </td>
                    </tr>
                    <tr>
                      <td>22 </td>
                      <td>ROUTE NO. 22</td>
                      <td>
                        Sector 37 d ,Sector 10 ,JMD Garden Sector 33 Gurgaon
                      </td>
                      <td>9289268522 </td>
                    </tr>
                    <tr>
                      <td>23 </td>
                      <td>ROUTE NO. 23</td>
                      <td>
                        Suncity Sector 54, Park Palace ,Verandah Sec-54 Sector
                        56 Gurgaon
                      </td>
                      <td>9289268523 </td>
                    </tr>
                    <tr>
                      <td>24 </td>
                      <td>ROUTE NO. 24</td>
                      <td>
                        Sushant lok I, Dlf Phase IV, A,B,C,Block Ridgewood
                        ,Regency Park 2<br />
                        Gurgaon, PWO Sector- 43, Sushant Estate
                      </td>
                      <td>9289268524 </td>
                    </tr>
                    <tr>
                      <td>25 </td>
                      <td>ROUTE NO. 25</td>
                      <td>Park View City I, Park view 2 Gurgaon ,Aron Villa</td>
                      <td>9289268525 </td>
                    </tr>
                    <tr>
                      <td>26 </td>
                      <td>ROUTE NO. 26</td>
                      <td>Vatika City Sector 49, Gurgaon</td>
                      <td>9289268526 </td>
                    </tr>
                    <tr>
                      <td>27 </td>
                      <td>ROUTE NO. 27</td>
                      <td>Orchid Petals Sector 49 ,Parshvanath Green Villa,</td>
                      <td>9289268527 </td>
                    </tr>
                    <tr>
                      <td>28 </td>
                      <td>ROUTE NO. 28</td>
                      <td>
                        Vatika Seven lamp,Cassavilla ,Coralwood Altima , Bestech
                        Park
                        <br />
                        View Grand Spa, Greenburg
                      </td>
                      <td>9289268528 </td>
                    </tr>
                    <tr>
                      <td>29 </td>
                      <td>ROUTE NO. 29</td>
                      <td>Palam Drive Sector 66 ,Gurgaon,</td>
                      <td>9289268529 </td>
                    </tr>
                    <tr>
                      <td>30 </td>
                      <td>ROUTE NO. 30</td>
                      <td>
                        Asiana Anmol Dhunela Sec-33 ,Ireo Uptown - 67 Gurgaon
                      </td>
                      <td>9289268500 </td>
                    </tr>
                    <tr>
                      <td>31 </td>
                      <td>ROUTE NO. 31</td>
                      <td>
                        Winter Hill Sec-77,Supertech Araville 79,Godrej Frontier
                        Sec-80 ,
                      </td>
                      <td>9818482227 </td>
                    </tr>
                    <tr>
                      <td>&nbsp; 32 </td>
                      <td>&nbsp; ROUTE NO. 32</td>
                      <td>
                        Ashok Vihar ,Sector 5 , Palam Vihar C1 ,C-2 Palam vihar,
                        A B C Block Sector 14 Gurgaon
                      </td>
                      <td>&nbsp; 9818462224 </td>
                    </tr>
                    <tr>
                      <td>33 </td>
                      <td>ROUTE NO. 33</td>
                      <td>Orchid Island ,Sec-51 , Sec- 45,</td>
                      <td>9560782224 </td>
                    </tr>
                    <tr>
                      <td>34 </td>
                      <td>ROUTE NO. 34</td>
                      <td>Sector 15, Part I &amp; II,Sector 40, Hewo APPt</td>
                      <td>9599837578 </td>
                    </tr>
                    <tr>
                      <td>35 </td>
                      <td>ROUTE NO .35</td>
                      <td>Sector 91, 92 ,Sector 86,Gurgaon</td>
                      <td>9599837579 </td>
                    </tr>
                    <tr>
                      <td>36 </td>
                      <td>ROUTE NO .36</td>
                      <td>Ansal Sector 66 ,Bptp Appt- Sec-67 Gurgaon</td>
                      <td>9599837580 </td>
                    </tr>
                    <tr>
                      <td>37 </td>
                      <td>ROUTE NO .37</td>
                      <td>GPl Sec-70a, Tulip Orange ,M3M Skaywak Sector 77</td>
                      <td>9599837581 </td>
                    </tr>
                    <tr>
                      <td>38 </td>
                      <td>ROUTE NO .38</td>
                      <td>Sec-46 , Prinstone floor , Sec-51, Sec-17 Ggn</td>
                      <td>9599837582 </td>
                    </tr>
                    <tr>
                      <td>39 </td>
                      <td>ROUTE NO .39</td>
                      <td>
                        Princeton Estate, Carlton Estate,Westend Height Gurgaon
                      </td>
                      <td>9599837583 </td>
                    </tr>
                    <tr>
                      <td>40 </td>
                      <td>ROUTE NO 40</td>
                      <td>Orchid petals Sector 49 ,Vatika City</td>
                      <td>9871001105 </td>
                    </tr>
                    <tr>
                      <td>41 </td>
                      <td>ROUTE NO 41</td>
                      <td>Wembley Estate Sec-50 Gurgaon</td>
                      <td>9650110911 </td>
                    </tr>
                    <tr>
                      <td>42 </td>
                      <td>ROUTE NO 42</td>
                      <td>Tata Raisina, Grand Arch Sec-58</td>
                      <td>9560011160 </td>
                    </tr>
                    <tr>
                      <td>43 </td>
                      <td>ROUTE NO 43</td>
                      <td>M3M Marina Sector 68, Tulip White ,Tulip Purple</td>
                      <td>9311743792 </td>
                    </tr>
                    <tr>
                      <td>44 </td>
                      <td>ROUTE NO 44</td>
                      <td>G Block South City 2 ,Nirvana Country Sec--50</td>
                      <td>9311961298 </td>
                    </tr>
                    <tr>
                      <td>45 </td>
                      <td>ROUTE NO 45</td>
                      <td>Tata Pramanti Sector 72 .Vipul Green Sona Road</td>
                      <td>9311743681 </td>
                    </tr>
                    <tr>
                      <td>46 </td>
                      <td>ROUTE NO 46</td>
                      <td>
                        Dwarka Expressway Sector 107, Sector 12, New Railway
                        road
                      </td>
                      <td>9311962674 </td>
                    </tr>
                    <tr>
                      <td>47 </td>
                      <td>ROUTE NO 47</td>
                      <td>
                        Coral Woods ,Antriksh Heights Sector 84 , Dlf The
                        Skycourt Sector
                        <br />
                        86 GGN
                      </td>
                      <td>9910220942 </td>
                    </tr>
                    <tr>
                      <td>48 </td>
                      <td>ROUTE NO 48</td>
                      <td>
                        Emaar Emerald Premier Floor Sector 65, Ireo Uptown
                        Sector 66
                      </td>
                      <td>9910220942 </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default BusRoute;
